import { render } from "./DisplayByCourses.vue?vue&type=template&id=6c3b2752&scoped=true"
import script from "./DisplayByCourses.vue?vue&type=script&lang=js"
export * from "./DisplayByCourses.vue?vue&type=script&lang=js"

import "./DisplayByCourses.vue?vue&type=style&index=0&id=6c3b2752&scoped=true&lang=css"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3b2752"]])

export default __exports__